/**
 * Created by Qingger Corp.
 * User: 陈儒
 * Date: 2019/11/1
 * Time: 14:57
 * Desc:
 */
import { Component, Vue, Watch } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import VueDraggableResizable from 'vue-draggable-resizable';
import Product from './product.vue';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';
import Upload from '@/views/components/upload/upload.vue';
import { noop } from '@/util';
import selectGoods from '@/views/components/selectGoods';
import imgPreview from '@/views/components/imgPreview';
import BindGoods from '@/views/pages/periodicalManage/bindGoods';
import { appEnvConfig } from '@/configs/appConfigs';
import { EmpServiceAPIActions } from '@/services/empService';
import Sketch from '@/views/components/sketch';
import validateParams from '@/library/utils/paramFilter';
import baseAPIService from '@/services/base/baseAPIService';
import NewSelectSite from '@/views/components/newSelectSIte';

const tencentVideo = 'https://v.qq.com/open/home.html';
const normalVideo = 'https://developers.weixin.qq.com/miniprogram/product/material';

@Component({
  components: {
    Upload,
    Product,
    Sketch,
    VueDraggableResizable,
  },
})
export default class PublishQiKan extends Vue {
  $refs: {
    form: ElForm;
  };

  //  预览组件的参数
  componentKeys = ['shareCard', 'sharePoster'];

  public tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  /* 图片上传地址 */
  public imgTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  /* 图片高度 */
  public targetHeight = 0;

  get componentData() {
    return [
      { img: this.qiKanInfo.shareCardPicture, title: this.qiKanInfo.qiKanContent },
      { img: this.qiKanInfo.sharePicture, title: this.qiKanInfo.qiKanContent },
    ];
  }

  /**
   * corpId
   */
  public corpId = baseAPIService.resolveCorpId();

  /**
   * 是否显示刘海屏
   */
  private isBangsShow = false;

  public editState = true;

  /**
   * 添加商品数量
   */
  public max = 150;

  // 期刊详情
  public qiKanInfo: Partial<QiKanFullInfo> = {
    qiKanId: 0,
    qiKanType: 1,
    qiKanCover: '',
    shareCardPicture: '',
    sharePicture: '',
    qiKanImgUrls: [],
    videoSource: 1,
    isAutoPlay: 0,
    qiKanProductCodeList: [],
    qiKanContent: '',
    _productList: [],
    qiKanLabelList: [],
    endTime: '',
    siteList: [],
  };

  public rule = {
    siteList: [{ required: true, message: '请选择适用网点', trigger: 'change' }],
    qiKanContent: [{ required: true, message: '请输入期刊描述', trigger: 'change' }],
    qiKanImgUrls: [{ required: true, message: '请选择期刊图片', trigger: 'change' }],
    endTime: [{ required: true, message: '请选择期刊有效期', trigger: 'change' }],
    qiKanLabelList: [{ required: true, message: '请选择话题标签', trigger: 'change' }],
    shareCardPicture: [{ required: true, message: '请选择分享卡片封面', trigger: 'change' }],
    sharePicture: [{ required: true, message: '请选择分享海报封面', trigger: 'change' }],

    imageUrl: [{ required: true, message: '请输入视频地址', trigger: 'change' }],
    // qiKanCover: [{ required: true, message: "请选择期刊封面", trigger: "change" }],
  };

  get qiKanImgUrls() {
    return this.qiKanInfo.qiKanImgUrls.map(d => d.imageUrl);
  }

  // 期刊类别 1 图片 2  视频
  public qiKanType = 1;

  public qiKanId = 0;

  // 选择网点
  openSelectSiteDialog(readonly) {
    new NewSelectSite().open({
      service: 'authTree',
      selectCodes: this.qiKanInfo.siteList,
      readonly: !readonly,
    }).then((val: string[]) => {
      this.qiKanInfo.siteList = val;
      this.$refs.form.validateField('siteList', noop);
    }, noop);
  }

  // 添加商品的弹窗
  openAddProductDialog() {
    selectGoods.open({ showBD: false, max: 30 }).then((res) => {
      this.qiKanInfo._productList = this.qiKanInfo._productList.concat(res.list);
      // 清除掉商品标注
      // this.qiKanInfo.qiKanImgUrls = this.qiKanInfo.qiKanImgUrls.map((i) => {
      //   i.goodsTagList = [];
      //   return i;
      // });
    });
  }

  // 清除相关商品
  clearProduct() {
    this.$confirm('是否重置已选商品?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then((res) => {
      if (res == 'confirm') {
        this.qiKanInfo._productList = [];
      }
    });
  }

  // 点此了解详情
  openNewWindow() {
    window.open(this.qiKanInfo.videoSource == 1 ? tencentVideo : normalVideo);
  }

  /**
   * 当前选中的期刊图片
   * @type {string}
   */
  public curPicObject: QiKanImagInfo = {
    imageUrl: '',
    // qImageId: 0,
    goodsTagList: [],
  };

  /**
   * 当前选中的期刊图片下标
   * @type {string}
   */
  public curPicIndex = 0;

  // 视频连接
  public videoUrlString = '';

  /**
   * 图片放大弹窗是否显示
   * @type {boolean}
   */
  public isMagnifyPopShow = false;

  /**
   * form列表
   * @type {ItemObject}
   */
  public productTagForm: { index?: number; productCode?: string; labelName?: string } = {
    index: 0,
    productCode: '',
    labelName: '点击绑定商品',
  };

  // 添加标签
  public addLabelFlag = false;

  // 解决 onmousedown onclick冲突开关
  public clickKeyFlag = false;

  // 根据商品货号搜索商品详情
  public productInfo: goodsInfo = {};

  // 相关商品 临时保存数据用
  public qiKanProductList: Array<any> = [];

  /** 网点相关*********************************8/
    /**
     * 页码
     * @type {number}
     */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 100;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 关键字
   * @type {string}
   */
  public keyword = '';

  /**
   * 关键字
   * @type {string}
   */
  public keywords = '';

  /**
   * 网点列表
   * @type {number}
   */
  public siteList: Array<SiteInfo> = [];

  /**
   * 是否选中列表项
   * @type {boolean}
   */
  public isSelected = false;

  /** 新增标签相关***************************/

  public labelFormString = ''; // 新增标签

  // 热门标签
  public qiKanHotLabelList: Array<{ labelName: string }> = [];

  public firstTime = 0;

  public lastTime = 0;

  /**
   * 图片上传地址
   * @type {string}
   */
  public fileTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  public mounted() {
    this.qiKanType = Number(this.$route.query.qiKanType);
    this.qiKanId = Number(this.$route.query.qiKanId) || 0;
    this.editState = !Number(this.$route.query.editState);
    this.qiKanInfo.qiKanType = this.qiKanType;

    if (this.qiKanType === 2) {
      this.qiKanInfo.qiKanImgUrls = [{ qImageId: 0, imageUrl: '' }];
    }
    // 期刊有效期默认延迟一个月
    if (!this.qiKanId) {
      this.qiKanInfo.endTime = moment().add(1, 'months').format('YYYY-MM-DD');
    }
    this.qiKanId && this.getQiKanInfo();

    this.getHotLabel();
  }

  onDeletePic(key) {
    this.qiKanInfo[key] = '';
  }

  onDeleteQiKanPic(index, item) {
    this.qiKanInfo.qiKanImgUrls.splice(index, 1);
  }

  onLiveMagnifyPic(item) {
    imgPreview.open({ img: item.imageUrl }).then(noop, noop);
  }

  public uploadShareCardPictureSuccess(res: any): void {
    this.qiKanInfo.shareCardPicture = res.content;
  }

  public uploadSharePictureSuccess(res: any): void {
    this.qiKanInfo.sharePicture = res.content;
  }

  /**
   * 图片上传失败
   * @return null
   */
  public uploadImgError(): void {
    this.$message.error('图片上传失败');
  }

  /**
   * 图片上传之前
   * @param {ItemObject} file
   * @return boolean
   */
  public onBeforeUpload(file: ItemObject): boolean {
    const isJpg = file.type === 'image/jpeg';
    const isPng = file.type === 'image/png';
    const isGif = file.type === 'image/gif';
    const LtSize = file.size / 1024 <= 1024;
    if (!isJpg && !isPng && !isGif) {
      this.$message.error('上传图片只能是 JPG/JPEG/PNG/GIF 格式!');
    }
    if (!LtSize) {
      this.$message.error('上传图片大小不能超过 1M!');
    }
    return (isJpg || isPng || isGif) && LtSize;
  }

  /**
   * 获取期刊详情
   *
   */
  public getQiKanInfo() {
    const me = this;
    const postParams = {
      qiKanId: this.qiKanId,
    };
    IPSService.adminPublishQiKanInfo({ postParams })
      .then((result: any) => {
        me.qiKanInfo = result;
        me.qiKanProductList = me.qiKanInfo.qiKanProductList || [];
        if(me.qiKanInfo.qiKanImgUrls.length===0){
          me.qiKanInfo.qiKanImgUrls = [{ qImageId: 0, imageUrl: '' }];
        }
        me.qiKanType == 2 && (me.videoUrlString = me.qiKanInfo.qiKanImgUrls[0].imageUrl);

        // 把标注里的商品设置为已标注
        const productList = this.qiKanInfo.qiKanProductList;
        const goodsList = [];
        if (this.qiKanInfo.qiKanImgUrls && this.qiKanInfo.qiKanImgUrls.length) {
          this.qiKanInfo.qiKanImgUrls.forEach((i) => {
            if (i.goodsTagList && i.goodsTagList.length) {
              i.goodsTagList.forEach((i) => {
                return goodsList.push(i.goodsCode);
              });
            }
          });
        }

        productList.map((i) => {
          if (goodsList.includes(i.productCode)) {
            i.mark = true;
          }
        });

        this.$set(this.qiKanInfo, '_productList', productList);

        // this.qiKanInfo._productList = productList;

        me.curPicIndex = 0;
        me.switchQiKanPicFn();
      })
      .catch((err) => {
        this.$message.error(err);
      });
  }

  private switchQiKanPicFn() {
    this.curPicObject = this.qiKanInfo.qiKanImgUrls[this.curPicIndex];
  }

  /**
   * upload组件上传成功后处理方法

   */
  public imgUploadSuccess(res) {
    // qikanType == 1 时 上传图片 等于2 上传封面
    if (this.qiKanType == 1) {
      // 新增上传
      this.qiKanInfo.qiKanImgUrls.push({
        qImageId: 0,
        imageUrl: res.content,
      });
      this.curPicIndex == 0 && this.switchQiKanPicFn();
    } else if (this.qiKanType == 2) {
      this.qiKanInfo = Object.assign({}, this.qiKanInfo, { qiKanCover: res.content });
    }
    this.$refs.form.validateField('qiKanImgUrls', noop);
  }

  imgHeight(el) {
    this.targetHeight = el.target.height;
  }

  /**
   * upload组件delete
   * @param list 删除后的图片url 数组
   * @param delIndex 删除的index
   */
  public imgUploadDelete(list, delIndex) {
    this.qiKanInfo.qiKanImgUrls.splice(delIndex, 1);
  }

  /**
   * 切换期刊图片
   * @param index
   */
  public switchQiKanPic(index) {
    // if(index>0){ //上翻}else{ //下翻}
    this.curPicIndex += index;
    this.switchQiKanPicFn();
  }

  public changeQiKanImg(index) {
    this.curPicIndex = index;
    this.switchQiKanPicFn();
  }

  // 删除商品
  onDeleteGoods(index) {
    this.$confirm('确定删除当前商品吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then((res) => {
      if (res === 'confirm') {
        // 查找，并删除关联删除商品的标签
        const productCode = `${this.qiKanInfo._productList[index].productCode}`;
        this.qiKanInfo.qiKanImgUrls = this.qiKanInfo.qiKanImgUrls.map((i) => {
          if (i.goodsTagList && i.goodsTagList.length) {
            i.goodsTagList = i.goodsTagList.filter((v) => {
              return v.goodsCode !== productCode;
            });
          }
          return i;
        });

        this.qiKanInfo._productList.splice(index, 1);
      }
    });
  }

  /**
   * 添加图片标签
   */
  public addGoodsTag() {
    this.curPicObject = Object.assign({}, { goodsTagList: [] }, this.curPicObject);
    const num = (this.curPicObject && this.curPicObject.goodsTagList ? this.curPicObject.goodsTagList.length : 0) + 1;
    const newItem = {
      goodsTagId: 0,
      goodsTagTitle: '点击编辑标签',
      goodsCode: '',
      position: { editPhoneWidth: 375, left: 30, top: num * 30 },
    };

    this.curPicObject.goodsTagList.splice(this.curPicObject.goodsTagList.length, 1, newItem);
    this.qiKanInfo.qiKanImgUrls.splice(this.curPicIndex, 1, this.curPicObject);
  }

  /**
   * 删除图片标签
   */
  public deleteProLabel(index) {
    this.curPicObject.goodsTagList.splice(index, 1);
    this.qiKanInfo.qiKanImgUrls.splice(this.curPicIndex, 1, this.curPicObject);
  }

  /**
   * 编辑期刊图片弹框
   * @param index
   */
  public editProTag(index) {
    if (this.editState) {
      return;
    }
    if (this.clickKeyFlag) {
      this.productInfo = {};
      this.productTagForm = {
        index,
        productCode: this.curPicObject.goodsTagList[index].goodsCode,
        labelName: this.curPicObject.goodsTagList[index].goodsTagTitle || this.productInfo.productName,
      };
      BindGoods.open({ goodsList: this.qiKanInfo._productList, productCode: this.productTagForm.productCode }).then((res) => {
        const index = this.productTagForm.index;
        const newItem: any = this.curPicObject.goodsTagList[index];
        newItem.goodsTagTitle = `￥${res.productOriginPrice || res.productPrice}`;
        // 标记为已标注
        newItem.mark = true;
        newItem.goodsCode = res.productCode;
        if (res.productCode !== this.productTagForm.productCode) {
          // 相关商品的标注
          this.qiKanInfo._productList.map((i) => {
            if (i.productCode === res.productCode) {
              i.mark = true;
            }
            if (i.productCode === this.productTagForm.productCode) {
              i.mark = false;
            }
          });
        }

        this.curPicObject.goodsTagList.splice(index, 1, newItem);
        this.qiKanInfo.qiKanImgUrls.splice(this.curPicIndex, 1, this.curPicObject);
      });
    }
  }

  @Watch('qiKanInfo', { deep: true })
  watchData(n) {
    this.switchQiKanPicFn();
  }

  public onMagnifyPic(url): void {
    imgPreview.open({ img: url }).then(noop, noop);
  }

  /**
   * 获取热门标签
   */
  public getHotLabel() {
    const me = this;
    const queryParams = {};
    IPSService.adminPublishQiKanPopularLabel({ queryParams }).then((res: any) => {
      me.qiKanHotLabelList = res || [];
    });
  }

  getEffectTag(item): 'light' | 'dark' {
    if (!this.qiKanInfo.qiKanLabelList || !this.qiKanInfo.qiKanLabelList.length) {
      return 'light';
    }
    if (this.qiKanInfo.qiKanLabelList.every(i => i.labelName !== item.labelName)) {
      return 'light';
    } else {
      return 'dark';
    }
  }

  /**
   * 添加标签
   * @param name
   * @param from
   */
  public addQiKanLabel(name, from) {
    if (!name) {
      this.$message.error('请填写标签名字！');
      return false;
    }
    if (this.qiKanInfo.qiKanLabelList.length >= 10) {
      this.$message.error('最多选择10个标签！');
      return false;
    }
    if (from == 'new') {
      this.labelFormString = '';
    }
    if (this.qiKanInfo.qiKanLabelList.every(i => i.labelName !== name)) {
      this.qiKanInfo.qiKanLabelList.splice(this.qiKanInfo.qiKanLabelList.length, 1, { labelName: name });
    }
  }

  onDrag() {
    this.clickKeyFlag = true;
  }

  onDragStop(x, y, index) {
    this.curPicObject.goodsTagList[index].position = { editPhoneWidth: 375, left: x, top: y };
    this.curPicObject.goodsTagList.splice(index, 1, this.curPicObject.goodsTagList[index]);
    this.qiKanInfo.qiKanImgUrls.splice(this.curPicIndex, 1, this.curPicObject);
    this.clickKeyFlag = false;
  }

  /**
   * 删除标签
   * @param index
   */
  public handleClose(index) {
    this.$confirm('此操作将删除该标签, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        this.qiKanInfo.qiKanLabelList.splice(index, 1);
      })
      .catch(() => {});
  }

  /**
   * 获取网点列表
   * @return null
   */
  public getSiteList(): void {
    const self = this;
    const queryParams = {
      page: this.page,
      pageSize: this.pageSize,
    };
    IPSService.adminPublishQiKanSiteList({ queryParams }).then((res: ItemObject) => {
      self.siteList = res.list;

      self.siteList = self.siteList.map((row) => {
        return {
          siteCode: row.siteCode,
          siteName: `${row.siteName}(${row.siteCode})`,
        };
      });
    });
  }

  /**
   * 返回列表页
   * @return null
   */
  public goBack(): void {
    this.$router.go(-1);
  }

  // 发布 、 编辑期刊
  public onSubmitPublish() {
    this.$refs.form.validate((flag) => {
      if (flag) {
        const loading = this.$loading({
          lock: true,
          text: '请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(225,225,225,0.3)',
        });
        const postParam = cloneDeep(this.qiKanInfo);
        // 赋值商品code
        postParam.qiKanProductCodeList = postParam._productList.map(i => i.productCode);
        // 过滤没添加商品标签 颜俊确认
        if (postParam.qiKanType === 1) {
          postParam.qiKanImgUrls = postParam.qiKanImgUrls.map((i) => {
            if (i.goodsTagList && i.goodsTagList.length) {
              i.goodsTagList = i.goodsTagList.filter((v) => {
                return !!v.goodsCode;
              });
            }
            return i;
          });
        }

        IPSService.adminPublishQiKanEdit({ postParams: validateParams(postParam) }).then((res) => {
          loading.close();
          if (res) {
            this.$message.success(`${this.qiKanId === 0 ? '新增' : '编辑'}成功`);
            setTimeout(() => {
              this.goBack();
            }, 1500);
          }
        });
      }
    });
  }

  // 预览seckill
  public onSubmitForPreview() {
    this.$refs.form.validate((flag) => {
      if (flag) {
        const postParam = cloneDeep(this.qiKanInfo);
        // 赋值商品code
        postParam.qiKanProductCodeList = postParam._productList.map(i => i.productCode);
        if (postParam.qiKanType === 1) {
          postParam.qiKanCover = postParam.qiKanImgUrls[0].imageUrl;
        }
        IPSService.adminPublishQiKanDisplay({ postParams: validateParams(postParam) })
          .then((res: ItemObject) => {
            imgPreview.open({ img: res.qiKanUrl }).then(noop, noop);
          })
          .catch((err) => {
            throw err;
          });
      }
    });
  }
}
